export const Breakpoints = {
  sm: 560,
  smmd: 720,
  md: 865,
  lg: 960,
  narrow: 1000,
  xl: 1440,
  xxl: 1600,
  header: 1100,
};

const brPx = {};
Object.keys(Breakpoints).map((key) => {
  brPx[key] = `${Breakpoints[key]}px`;
});

export const BreakpointsWithPx = brPx;

